import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
const DEF = { name:'', description:'', type:'static', color:'#1e40af', icon:'🖥', criteria:{} };

export default function DeviceGroups({ user }) {
  const [groups,  setGroups]  = useState([]);
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg,     setMsg]     = useState({ text:'', type:'' });
  const [tab,     setTab]     = useState('groups');
  const [showForm,setShowForm]= useState(false);
  const [form,    setForm]    = useState(DEF);
  const [saving,  setSaving]  = useState(false);
  const [assignModal, setAssignModal] = useState(null);
  const [selDevs, setSelDevs] = useState([]);
  const [bulkCsv, setBulkCsv] = useState('');
  const [bulkResult, setBulkResult] = useState(null);
  const [bulkRunning, setBulkRunning] = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  const load = useCallback(async () => {
    try { const [g,d] = await Promise.all([axios.get('/api/device-groups',auth()),axios.get('/api/agents',auth())]); setGroups(g.data); setDevices(d.data.filter?d.data.filter(d=>!d.archivedAt):d.data); } catch(e) { flash('Failed','error'); } finally { setLoading(false); }
  },[]);
  useEffect(()=>{ load(); },[load]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try { await axios.post('/api/device-groups',form,auth()); flash('Group created'); setShowForm(false); setForm(DEF); load(); } catch(e) { flash('Failed','error'); } finally { setSaving(false); }
  }
  async function del(id) { if(!window.confirm('Delete?'))return; try{await axios.delete(`/api/device-groups/${id}`,auth());flash('Deleted');load();}catch{flash('Failed','error');} }
  async function assign() {
    if(!selDevs.length||!assignModal)return;
    try{const r=await axios.post(`/api/device-groups/${assignModal}/members`,{deviceIds:selDevs},auth());flash(`Added ${r.data.added} device(s)`);setAssignModal(null);setSelDevs([]);load();}catch(e){flash('Failed','error');}
  }
  async function runBulk() {
    if(!bulkCsv.trim())return;
    setBulkRunning(true);
    try{const r=await axios.post('/api/device-groups/bulk-enroll',{csv:bulkCsv},auth());setBulkResult(r.data);}catch(e){flash(e.response?.data?.error||'Failed','error');}finally{setBulkRunning(false);}
  }

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Device Groups</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Organize devices into groups for bulk targeting, policy, and job execution</p></div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Group</button>
      </div>
      <div style={{display:'flex',gap:2,marginBottom:16,borderBottom:'2px solid #f1f5f9'}}>
        {[['groups','Groups'],['tags','Device Tags'],['bulk','Bulk CSV Enrollment']].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{padding:'8px 16px',border:'none',borderBottom:tab===id?'2px solid #1e40af':'2px solid transparent',background:'none',cursor:'pointer',fontWeight:600,fontSize:13,color:tab===id?'#1e40af':'#64748b',marginBottom:-2}}>{label}</button>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> : tab==='groups' ? (
        groups.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>👥</div><div style={{fontWeight:600,marginTop:12}}>No groups yet</div></div> : (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))',gap:14}}>
            {groups.map(g=>(
              <div key={g.id} style={{background:'#fff',border:`2px solid ${g.color}30`,borderRadius:12,padding:18}}>
                <div style={{display:'flex',gap:10,alignItems:'center',marginBottom:10}}>
                  <div style={{width:40,height:40,borderRadius:9,background:`${g.color}20`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>{g.icon}</div>
                  <div>
                    <div style={{fontWeight:700,fontSize:14}}>{g.name}</div>
                    <div style={{fontSize:11,color:'#64748b'}}>{g.type} · {g.deviceCount||0} devices</div>
                  </div>
                </div>
                {g.description&&<div style={{fontSize:12,color:'#64748b',marginBottom:10}}>{g.description}</div>}
                <div style={{display:'flex',gap:8}}>
                  <button onClick={()=>{setAssignModal(g.id);setSelDevs([]);}} style={{flex:1,background:'#1e40af',color:'#fff',border:'none',borderRadius:7,padding:'7px',fontSize:12,fontWeight:600,cursor:'pointer'}}>+ Add Devices</button>
                  <button onClick={()=>del(g.id)} style={{background:'#fee2e2',border:'none',borderRadius:7,padding:'7px 10px',fontSize:12,cursor:'pointer',color:'#dc2626'}}>🗑</button>
                </div>
              </div>
            ))}
          </div>
        )
      ) : tab==='tags' ? (
        <TagsPanel auth={auth} devices={devices} flash={flash} />
      ) : (
        <div style={{maxWidth:700}}>
          <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:'14px 18px',marginBottom:16}}>
            <div style={{fontWeight:700,color:'#0369a1',marginBottom:6}}>CSV Format</div>
            <code style={{fontSize:12,color:'#0c4a6e'}}>hostname,department,ring,type</code><br/>
            <code style={{fontSize:12,color:'#0c4a6e'}}>LP000001,Finance,production,workstation</code><br/>
            <code style={{fontSize:12,color:'#0c4a6e'}}>LP000002,IT,test,server</code>
          </div>
          <textarea value={bulkCsv} onChange={e=>setBulkCsv(e.target.value)} rows={8} placeholder="hostname,department,ring,type&#10;LP000001,Finance,production,workstation&#10;LP000002,IT,test,server" style={{width:'100%',padding:12,border:'1px solid #d1d5db',borderRadius:8,fontSize:13,fontFamily:'monospace',boxSizing:'border-box',resize:'vertical',marginBottom:12}} />
          <button onClick={runBulk} disabled={bulkRunning||!bulkCsv.trim()} style={{padding:'10px 24px',background:bulkRunning?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:bulkRunning?'default':'pointer'}}>
            {bulkRunning ? 'Processing...' : '📋 Generate Enrollment Tokens'}
          </button>
          {bulkResult && (
            <div style={{marginTop:16,background:'#f0fff4',border:'1px solid #bbf7d0',borderRadius:10,padding:16}}>
              <div style={{fontWeight:700,color:'#15803d',marginBottom:10}}>✔ {bulkResult.enrolled} devices ready to enroll</div>
              {bulkResult.tokens?.slice(0,5).map((t,i)=>(
                <div key={i} style={{background:'#1e293b',borderRadius:6,padding:'8px 12px',marginBottom:6,fontFamily:'monospace',fontSize:11,color:'#e2e8f0',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                  {t.hostname}: {t.installCmd}
                </div>
              ))}
              {bulkResult.enrolled>5&&<div style={{fontSize:12,color:'#64748b'}}>...and {bulkResult.enrolled-5} more</div>}
            </div>
          )}
        </div>
      )}

      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:480,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Device Group</h3>
            <form onSubmit={save}>
              {[['Name*','name'],['Description','description']].map(([l,k])=>(
                <div key={k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              ))}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:20}}>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Type</label>
                  <select value={form.type} onChange={e=>setForm({...form,type:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    <option value="static">Static (manual)</option><option value="dynamic">Dynamic (auto)</option>
                  </select></div>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Color</label>
                  <input type="color" value={form.color} onChange={e=>setForm({...form,color:e.target.value})} style={{width:'100%',height:40,border:'1px solid #d1d5db',borderRadius:8,cursor:'pointer'}} /></div>
              </div>
              {form.type==='dynamic'&&(
                <div style={{marginBottom:20}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Criteria (JSON)</label>
                  <textarea value={JSON.stringify(form.criteria,null,2)} onChange={e=>{try{setForm({...form,criteria:JSON.parse(e.target.value)})}catch(_){}}} rows={3} style={{width:'100%',padding:10,border:'1px solid #d1d5db',borderRadius:8,fontSize:12,fontFamily:'monospace',boxSizing:'border-box'}} />
                  <div style={{fontSize:11,color:'#64748b',marginTop:3}}>e.g. {`{"osType":"windows","ring":"production"}`}</div>
                </div>
              )}
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {assignModal&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:460,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 16px',fontSize:18,fontWeight:700}}>Add Devices to Group</h3>
            <div style={{maxHeight:220,overflow:'auto',border:'1px solid #e2e8f0',borderRadius:8,marginBottom:16}}>
              {devices.map(d=>(
                <label key={d.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',borderBottom:'1px solid #f8fafc',cursor:'pointer',background:selDevs.includes(d.id)?'#eff6ff':'#fff'}}>
                  <input type="checkbox" checked={selDevs.includes(d.id)} onChange={e=>setSelDevs(s=>e.target.checked?[...s,d.id]:s.filter(x=>x!==d.id))} />
                  <span style={{flex:1,fontSize:13,fontWeight:500}}>{d.hostname}</span>
                  <span style={{fontSize:11,color:d.status==='online'?'#16a34a':'#94a3b8',fontWeight:600}}>{d.status==='online'?'●':'○'} {d.status}</span>
                </label>
              ))}
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
              <button onClick={()=>setAssignModal(null)} style={{padding:'9px 18px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
              <button onClick={assign} disabled={!selDevs.length} style={{padding:'9px 18px',background:selDevs.length?'#1e40af':'#94a3b8',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:selDevs.length?'pointer':'default'}}>Add {selDevs.length} Devices</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TagsPanel({ auth, devices, flash }) {
  const [tags, setTags] = useState([]);
  const [key,  setKey]  = useState('');
  const [val,  setVal]  = useState('');
  const [selDevs, setSelDevs] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(()=>{ axios.get('/api/device-groups/tags',auth()).then(r=>setTags(r.data.tags||[])).catch(()=>{}); },[]);

  async function addTag(e) {
    e.preventDefault(); if(!key||!val||!selDevs.length) return;
    setSaving(true);
    try { await axios.post('/api/device-groups/tags',{deviceIds:selDevs,key,value:val},auth()); flash('Tag added'); setKey('');setVal('');setSelDevs([]); const r=await axios.get('/api/device-groups/tags',auth()); setTags(r.data.tags||[]); }
    catch(e) { flash('Failed','error'); } finally { setSaving(false); }
  }

  const grouped = {};
  tags.forEach(t=>{ if(!grouped[t.key]) grouped[t.key]=[]; if(!grouped[t.key].find(x=>x.value===t.value)) grouped[t.key].push(t); });

  return (
    <div style={{maxWidth:700}}>
      <form onSubmit={addTag} style={{background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:10,padding:16,marginBottom:20}}>
        <div style={{fontWeight:700,fontSize:14,marginBottom:12}}>Add Tag to Devices</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
          <input value={key} onChange={e=>setKey(e.target.value)} placeholder="Key (e.g. department)" style={{padding:'8px 12px',border:'1px solid #d1d5db',borderRadius:7,fontSize:13}} />
          <input value={val} onChange={e=>setVal(e.target.value)} placeholder="Value (e.g. finance)" style={{padding:'8px 12px',border:'1px solid #d1d5db',borderRadius:7,fontSize:13}} />
        </div>
        <div style={{maxHeight:120,overflow:'auto',border:'1px solid #e2e8f0',borderRadius:7,background:'#fff',marginBottom:10}}>
          {devices.map(d=><label key={d.id} style={{display:'flex',gap:8,padding:'5px 10px',cursor:'pointer',background:selDevs.includes(d.id)?'#eff6ff':'#fff'}}>
            <input type="checkbox" checked={selDevs.includes(d.id)} onChange={e=>setSelDevs(s=>e.target.checked?[...s,d.id]:s.filter(x=>x!==d.id))} />
            <span style={{fontSize:12}}>{d.hostname}</span>
          </label>)}
        </div>
        <button type="submit" disabled={saving||!key||!val||!selDevs.length} style={{padding:'8px 20px',background:'#1e40af',color:'#fff',border:'none',borderRadius:7,fontWeight:600,cursor:'pointer',fontSize:13}}>{saving?'Adding...':'Add Tag'}</button>
      </form>
      {Object.entries(grouped).map(([tagKey,tagVals])=>(
        <div key={tagKey} style={{marginBottom:14}}>
          <div style={{fontWeight:700,fontSize:13,color:'#374151',marginBottom:6}}>{tagKey}</div>
          <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
            {tagVals.map(t=><span key={t.id} style={{background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:5,padding:'3px 10px',fontSize:12,color:'#475569'}}>{t.value}</span>)}
          </div>
        </div>
      ))}
    </div>
  );
}
